import React from "react";
import Row from "../../../../../bootstrap/component/Row";
import Column from "../../../../../bootstrap/component/Column";
import {BACKEND_URL} from "../../../../../../util/api";

const DOWNLOAD_URL = BACKEND_URL + '/api/customer/download-images?customerId=';

const getDownloadUrlWith = (customerId) => {
    return DOWNLOAD_URL + customerId;
}

const DownloadImages = ({customerId}) => {
    return (
        <Row>
            <Column>
                <a href={getDownloadUrlWith(customerId)}>download</a>
            </Column>
        </Row>
    )
}

export default DownloadImages;



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/components/DownloadImages.js